const repairList = {
  repairList: "Repair Log",
  search: "Search",
  equipmentTag: "Equipment Tag",
  customer: "Customer",
  repairDate: "Repair Date",
  wasReplaced: "was replaced",
  addSparePart: "Add consumable",
  lastChangeWas: "The last change was",
  itHasToBe: "It has to be replaced each",
  nextChange: "The next change have to be the",
  changeOrEdit: "Change or edit the element",
  deletePart: "Delete the element",
  createReapirLog: "Create repair log",
  type: "Type",
  consumable: "Consumbale",
  log: "Log",
  itemsPerPage: "Rows per page",
  itemsPerPageAllText: "All",
  CREATED: "CREATED",
  REPAIR: "REPAIR",
  UPDATE: "UPDATE",
  year: "year",
  years: "years",
  month: "month",
  months: "months",
  week: "week",
  weeks: "weeks",
  day: "day",
  days: "days",
  hour: "hour",
  hours: "hours",
  minute: "minute",
  minutes: "minutes",
  second: "second",
  seconds: "seconds",
  headers: {
    taskName: "Task Name",
    taskDescription: "Description",
    taskDate: "Task Date"
  }
};
export default repairList;
